import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import Player from '@vimeo/player'
// import useMouseMoving from '~utils/useMouseMoving'
import Image from '~components/Image'
// import { SoundOn, SoundOff } from '~components/Svg'
import { getVimeoOptions } from '~utils/vimeo'

const Vimeo = ({ className, videoId, relativeHeight, placeholder, aspectRatio, width, height, showControls }) => {
	// const [play, setPlay] = useState(false)
	const [player, setPlayer] = useState()
	// const [hover, setHover] = useState()
	// const [mouseMoving] = useMouseMoving()
	const [initialPlay, setInitialPlay] = useState(false)
	// const [muted, setMuted] = useState(true)

	console.log(width, height)

	// Vimeo variables

	const videoContainer = useCallback((node) => {
		let options = getVimeoOptions(videoId, showControls)
		if (node && videoId) setPlayer(new Player(node, options))
	}, [])

	const playVideo = () => {
		!initialPlay && setInitialPlay(true)
		// setPlay(true)
		player?.play()
	}

	// useEffect(() => {
	// 	player?.on('play', function () {
	// 		// data is an object containing properties specific to that event
	// 		setInitialPlay(true)
	// 	})
	// }, [play])

	// useEffect(() => {
	// 	if (initialPlay) {
	// 		player
	// 			.getMuted()
	// 			.then(function (vimeoMuted) {
	// 				// careful here -- the arg above comes from the getMuted() call,
	// 				// and not the state variable {muted}
	// 				setMuted(vimeoMuted)
	// 			})
	// 			.catch(function (error) {
	// 				console.log(error)
	// 				// an error occurred
	// 			})
	// 	}
	// }, [initialPlay])

	// const toggleMuted = () => {
	// 	if (!muted) {
	// 		player
	// 			.setMuted(true)
	// 			.then(function (vimeoMuted) {
	// 				setMuted(true)
	// 			})
	// 			.catch(function (error) {
	// 				// an error occurred
	// 			})
	// 	} else if (muted) {
	// 		player
	// 			.setMuted(false)
	// 			.then(function (vimeoMuted) {
	// 				setMuted(false)
	// 			})
	// 			.catch(function (error) {
	// 				// an error occurred
	// 			})
	// 	}
	// }

	// const fullscreenCss = css`
	// 		pointer-events: none;
	// 		position: relative;
	// 		overflow: hidden;
	// 		width: 100vw;
	// 		height: 100vh;
	// 		:after {
	// 			content: '';
	// 			position: absolute;
	// 			display: block;
	// 			z-index: 100;
	// 			top: 0;
	// 			bottom: 0;
	// 			right: 0;
	// 			left: 0;
	// 			opacity: 0.3;
	// 			pointer-events: none;
	// 		}
	// 		iframe {
	// 			position: absolute;
	// 			top: 50%;
	// 			left: 50%;
	// 			width: 100vw;
	// 			height: 100vh;
	// 			transform: translate(-50%, -50%);
	// 			@media (min-aspect-ratio: 16/9) {
	// 				/* if aspect ratio is lower than 1.777 video needs to be full width*/
	// 				width: ${aspectRatio <= 1.78 ? '100vw' : `calc(100vh * ${aspectRatio})`};
	// 				height: ${aspectRatio <= 1.78 ? `calc(100vw / ${aspectRatio})` : '100vh'};
	// 			}
	// 			@media (max-aspect-ratio: 16/9) {
	// 				width: ${aspectRatio * 100 + 'vh'};
	// 			}
	// 		}
	// 	`

	// const containedCss = css`
	// 	position: relative;
	// 	width: 100vw;
	// 	> iframe {
	// 		width: 100vw;
	// 		height: 100vh;
	// 	}
	// `

	return (
		<Wrap className={className}>
			<Inner relativeHeight={relativeHeight}>
				<Placeholder cover image={placeholder} playing={initialPlay} />
				<PlayButton className="h1" onClick={playVideo} play={initialPlay}>
					Play
				</PlayButton>
				{videoId &&
					<Video
						ref={videoContainer}
						css={css`
							height: 100%;
							aspect-ratio: ${aspectRatio};
						`}
					/>
				}
			</Inner>
		</Wrap >
	)
}

const Wrap = styled.div``

const Video = styled.div`
	position: relative;
	height: 0;
	overflow: hidden;
	max-width: 100%;
	width: 100%;
	transition: opacity 1s;
	iframe {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
`
// const Relative = styled.div`
// 	position: relative;
// 	height: 100%;
// `
// const VideoFull = styled.div`
// 	position: absolute;
// 	top: 0;
// 	left: 0;
// 	bottom: 0;
// 	right: 0;
// `
const Inner = styled.div`
	height: ${(props) => (props.relativeHeight ? 'auto' : '100vh')};
	position: relative;
`
const Placeholder = styled(Image)`
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 2;
	opacity: ${(props) => (props.playing ? '0' : '1')};
	pointer-events: ${(props) => (props.playing ? 'none' : 'all')};
	transition: opacity 0.3s;
`

const PlayButton = styled.button`
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	width: 100%;
	text-align: center;
	/* transform: translate(50%, -50%); */
	color: var(--white);
	z-index: 10;
	pointer-events: ${(props) => (props.play ? 'none' : 'all')};
	opacity: ${(props) => (props.play ? '0' : '1')};
	transition: opacity 0.2s;
`
// const PauseButton = styled(PlayButton)`
// 	pointer-events: ${(props) => (props.play && props.show ? 'all' : 'none')};
// 	opacity: ${(props) => (props.play && props.show ? '1' : '0')};
// `
// const SoundButton = styled.button`
// 	color: white;
// 	position: absolute;
// 	z-index: 10;
// 	bottom: 28px;
// 	right: 28px;
// 	line-height: 0;
// 	width: 26px;
// 	height: 30px;
// 	pointer-events: ${(props) => (props.play && props.show ? 'all' : 'none')};
// 	opacity: ${(props) => (props.play && props.show ? '1' : '0')};
// 	transition: opacity 0.2s;
// `

Vimeo.propTypes = {
	className: PropTypes.string,
	videoId: PropTypes.number,
	relativeHeight: PropTypes.bool,
	placeholder: PropTypes.object,
	aspectRatio: PropTypes.number,
	width: PropTypes.number,
	height: PropTypes.number,
	showControls: PropTypes.boolean,
}

export default Vimeo
